// TODO: remove after bouncex/wunderkind decommission

import waitFor from './waitFor.js';

async function waitForBounceX() {
  try {
    // Wait for window.bouncex to exist with a timeout of X seconds
    await Promise.race([
      waitFor(
        () =>
          window.hasOwnProperty('bouncex') &&
          // Value is originally initialized without campaigns defined and
          // when the script fully resolves campaigns exists
          window.bouncex.hasOwnProperty('campaigns'),
      ),
      new Promise((_, reject) =>
        setTimeout(
          () =>
            reject(
              'waiting for bouncex initialization timed out after 10 seconds',
            ),
          6000,
        ),
      ),
    ]);
  } catch (e) {
    console.error(
      'Web.Zephr:onZephrInitializeComponent:error: while waiting for window.bouncex to initialize',
      e,
    );
  }
}

export default waitForBounceX;
